<template>
  <div>
    <modal
      class="new-modal-small"
      :name="modal_name"
      transition="nice-modal-fade"
      :delay="100"
      height="auto"
      :pivot-y="0.5"
      :adaptive="true"
      :scrollable="false"
      style="pointer-events:inherit !important" 
      v-bind:click-to-close="false"
    >
      <div
        class="v-modal-content d-flex flex-column justify-content-center align-items-center text-center"
        style="background-color: #ffffff !important"
      >
        <div
          class="w-100 bg-secondary d-flex align-items-center justify-content-center text-white"
          style="height: 50px"
        >
          <p class="text-center mt-2 fw-500" style="font-size: 16px">
            Add Note
          </p>
          <div>
            <span
              class="icon icon-close mr-2 mb-1 text-white pointer close-left"
              @click="hideSelf"
            ></span>
          </div>
        </div>
        <div class="w-1oo mb-3 mt-4 mr-2 ml-2">
          <div class="p-5">
            <div class="d-flex justify-content-start text-secondary mb-1 fs-12">
              Message
            </div>
            <div>
              <textarea
                style="height: 90px !important; width: 423px !important; border: 1px solid grey; border-radius: 4px; padding: 2px 5px 2px 5px;"
                v-model="notes"
                rows="8"
                placeholder="Enter Notes"
              ></textarea>
            </div>
          </div>
          <div class="d-flex aligin-items-center justify-content-center mb-6">
            <button
              type="button"
              class="btn mx-5 btn-xlg text-secondary"
              style="
                box-shadow: none;
                background-color: white;
                border: 1px solid #00448b;
              "
              @click="hideSelf"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-new-primary btn-xlg"
              style="box-shadow: none; min-width: 5rem"
              @click="sendRequest"
            >
              Send Request
            </button>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      notes: "",
    };
  },
  props: ["modal_name"],
  methods: {
    hideSelf() {
      this.notes = '';
      this.$modal.hide(this.modal_name);
    },
    sendRequest() {
      this.$modal.hide(this.modal_name);
      this.$emit("sendRequest", this.notes);
    },
    AddNote() {
      this.$modal.hide(this.modal_name);
      this.$emit("AddNote");
    },
  },
};
</script>
<style scoped>
.btn-xlg {
  text-transform: none !important;
  border-radius: 6px;
  width:130px;

}
</style>


// WEBPACK FOOTER //
// src/components/alertModals/AddNote.vue